/* eslint-disable import/no-anonymous-default-export */

import { useContext, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { formatListData, AjaxContext, formatPrevTournamentListData, EMPTY_ARRAY } from 'commons-ui';
import _keys from 'lodash/keys';
import _forEach from 'lodash/forEach';
import * as lodash from 'lodash';
import { IAppRequestPayload } from './constants';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const getTournamentList = useCallback(
		async (
			{
				app
			}: {
				app: { displayName?: string; appName: string; isGold: boolean };
			},
			gameName?: string
		) => {
			const { appName } = app;
			try {
				const result = await postData({
					endpoint: '/marketing/dashboard/tournament/listTournamentObjects',
					body: {
						gameName: gameName || 'ludo'
					},
					queryParams: {
						appName
					}
				});
				return {
					rowCount: lodash.get(result, 'data.data.length', 0),
					data: lodash.get(result, 'data.data', EMPTY_ARRAY),
					iAmApprover: lodash.get(result, 'data.iAmApprover', false)
				};
			} catch (error) {
				return { rowCount: 0, data: [], iAmApprover: false };
			}
		},
		[]
	);
	const getTournamentConfigs = useCallback(
		async (
			{
				app
			}: {
				app: { displayName?: string; appName: string; isGold: boolean };
			},
			gameName?: string
		) => {
			// const { appName } = app;
			const prevTournamentList = await getTournamentList({ app }, gameName);
			const reqdList: any = [];
			formatPrevTournamentListData(prevTournamentList, reqdList);
			const listData = formatListData(reqdList);
			return { rowCount: reqdList.length, data: listData };
		},
		[]
	);

	const requestCreateTournament = useCallback((appName: any, data: any) => {
		const formData = new FormData();
		_forEach(_keys(data), (key: string) => {
			formData.append(key, data[key]);
		});
		const options: {
			endpoint: string;
			body: any;
			customHeaders: any;
			queryParams: any;
			baseUrlFromParams?: string;
		} = {
			endpoint: '/marketing/dashboard/tournament/uploadTournamentCsv',
			body: formData,
			customHeaders: { 'Content-Type': 'multipart/form-data' },

			queryParams: {
				appName
			}
		};
		return postData(options);
	}, []);

	const requestCsvDiff = useCallback((appName: any, data: any) => {
		const formData = new FormData();
		_forEach(_keys(data), (key: string) => {
			formData.append(key, data[key]);
		});
		const options: {
			endpoint: string;
			body: any;
			customHeaders: any;
			queryParams: any;
			baseUrlFromParams?: string;
		} = {
			endpoint: '/marketing/dashboard/tournament/getTournamentDiff',
			body: formData,
			customHeaders: { 'Content-Type': 'multipart/form-data' },

			queryParams: {
				appName
			}
		};
		return postData(options);
	}, []);

	const rollbackTournamentFile = useCallback(
		async (
			{
				app
			}: {
				app: { displayName?: string; appName: string; isGold: boolean };
			},
			payload
		) => {
			const { appName } = app;
			const result = await postData({
				endpoint: '/marketing/dashboard/tournament/rollbackTournamentFile',
				body: {
					docId: payload.docId,
					gameName: payload.gameName
				},
				queryParams: {
					appName
				}
			});
			return { success: result?.data?.success, status: result.status };
		},
		[]
	);

	const approveTournamentCsvService = useCallback(
		async (
			{
				app
			}: {
				app: IAppRequestPayload;
			},
			payload
		) => {
			const { appName } = app;
			const result = await postData({
				endpoint: '/marketing/dashboard/tournament/approveTournamentCsv',
				body: {
					docId: payload.docId,
					gameName: payload.gameName
				},
				queryParams: {
					appName
				}
			});
			return { success: result?.data?.success, status: result.status };
		},
		EMPTY_ARRAY
	);

	const getTournamentCsvStatus = useCallback(
		async (
			{
				app
			}: {
				app: { displayName?: string; appName: string; isGold: boolean };
			},
			payload
		) => {
			const { appName } = app;
			const result = await postData({
				endpoint: '/marketing/dashboard/tournament/getTournamentCsvStatus',
				body: {
					docId: payload.docId,
					environment: payload.environment
				},
				queryParams: {
					appName
				}
			});
			return result;
		},
		[]
	);

	const handleFormCancel = () => {
		history.goBack();
	};

	const requestActivateTournamentSpec = useCallback(
		async (app: { displayName?: string; appName: string; isGold: boolean }, specId: any) => {
			const { isGold, appName } = app;
			return postData({
				endpoint: '/marketing/dashboard/tournament/activateSpec',
				body: { specId, isGold },
				queryParams: { appName }
			});
		},
		[]
	);

	const requestGetLastDeployedTournamentSpec = useCallback(
		async (app: { displayName?: string; appName: string; isGold: boolean }) => {
			const { isGold, appName } = app;
			const result = await postData({
				endpoint: '/marketing/dashboard/tournament/getLastDeployedSpec',
				body: { isGold },
				queryParams: { appName }
			});
			const lastDeployedTournamentSpec = result?.data?.tournamentSpec;

			return lastDeployedTournamentSpec;
		},
		[]
	);

	return {
		getTournamentConfigs,
		requestCreateTournament,
		requestActivateTournamentSpec,
		requestGetLastDeployedTournamentSpec,
		handleFormCancel,
		showLoader,
		setShowLoader,
		getTournamentList,
		rollbackTournamentFile,
		getTournamentCsvStatus,
		requestCsvDiff,
		approveTournamentCsvService
	};
};

export default useService;
